import { render } from "./TagBadges.vue?vue&type=template&id=2e4cb2da&scoped=true"
import script from "./TagBadges.vue?vue&type=script&lang=js"
export * from "./TagBadges.vue?vue&type=script&lang=js"

import "./TagBadges.vue?vue&type=style&index=0&id=2e4cb2da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4cb2da"]])

export default __exports__